// Runtime <head> sync for a single-page app: on every route change, set the
// title, description, canonical and Open Graph tags from content/seo.js so a
// crawler that does run JS (and every share) sees the right page, not the
// home page's defaults.
import { SITE, pageFor, isNoIndex } from '../content/seo';

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

// Pages with their own dynamic head (event pages, overlay) set title themselves;
// we only touch pages listed in content/seo.js plus the robots flag.
export const applySeo = (pathname) => {
  if (typeof document === 'undefined') return null;
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  if (isNoIndex(path)) {
    upsertMeta('name', 'robots', 'noindex, nofollow');
    return null;
  }
  const robots = document.head.querySelector('meta[name="robots"]');
  if (robots) robots.remove();

  const page = pageFor(path);
  if (!page) return null;
  const url = `${SITE.url}${path === '/' ? '/' : path}`;
  document.title = page.title;
  upsertMeta('name', 'description', page.description);
  upsertMeta('property', 'og:title', page.title);
  upsertMeta('property', 'og:description', page.description);
  upsertMeta('property', 'og:url', url);
  upsertMeta('name', 'twitter:title', page.title);
  upsertMeta('name', 'twitter:description', page.description);
  upsertLink('canonical', url);
  return page;
};
